<div class="panel-header-container">
        <div class="panel-header-row">
            <table class="full-width" >
                <tr class="custom-table-row">
                    <td class="no-child-table-definition">{{ 'SUB_TOTALS' | translate}}</td>
                    <td class="estimate-table-column width-110">
                        {{ subTotalsFormGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ subTotalsFormGroup.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-210 padding-gm">{{ subTotalsFormGroup.controls.grossMargin.value | multilingualCurrency}}</td>
                    <td class="estimate-table-column width-110">{{ subTotalsFormGroup.controls.sellPrice.value | multilingualCurrency}}</td>
                </tr>
            </table>
        </div>
    </div>